import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useACRPermissions = () => {
  const { canAccess } = useUser()

  const canViewACR = canAccess(permissionType.TAB_ABANDONED_CHECKOUTS, 0)
  const canAccessExitFormConfig = canAccess(permissionType.EXIT_FORM_CONFIG, 0)
  const canExportACRData = canAccess(permissionType.EXPORT_ABC_DATA, 0)
  const canPlaceOrder = canAccess(permissionType.PLACE_BY_ACR, 0)

  return {
    canViewACR,
    canAccessExitFormConfig,
    canExportACRData,
    canPlaceOrder
  }
}
